import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { ImageUp } from 'lucide-react';

// Dropzone for the SOLS screenshot, styled to sit directly on the tab's
// gradient surface. Shows OCR progress while a file is being read.
const FileUpload = ({ onFileUpload, isProcessing, progress = 0 }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0 && !isProcessing) {
        onFileUpload(acceptedFiles[0]);
      }
    },
    [onFileUpload, isProcessing]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp'],
    },
    multiple: false,
    disabled: isProcessing,
  });

  return (
    <div
      {...getRootProps()}
      className={`rounded-3xl border-2 border-dashed px-6 py-10 text-center transition-colors cursor-pointer select-none ${
        isDragActive
          ? 'border-mint-300 bg-white/10'
          : 'border-white/30 hover:border-white/50 bg-white/[0.06]'
      } ${isProcessing ? 'cursor-wait' : ''}`}
    >
      <input {...getInputProps()} />

      {isProcessing ? (
        <div className="max-w-[220px] mx-auto">
          <p className="text-sm font-medium text-white">Reading your grades…</p>
          <div className="mt-3 h-1.5 rounded-full bg-white/20 overflow-hidden">
            <div
              className="h-full rounded-full bg-mint-300 transition-all duration-200"
              style={{ width: `${Math.round(progress * 100)}%` }}
            />
          </div>
          <p className="mt-2 text-xs text-white/60">{Math.round(progress * 100)}%</p>
        </div>
      ) : (
        <>
          <div className="mx-auto w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center">
            <ImageUp className="w-6 h-6 text-mint-200" />
          </div>
          <p className="mt-4 text-[15px] font-semibold text-white">
            {isDragActive ? 'Release to scan' : 'Drop your SOLS screenshot'}
          </p>
          <p className="mt-1 text-sm text-white/60">or tap to choose from your photos</p>
        </>
      )}
    </div>
  );
};

export default FileUpload;
